let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4Mr42")).then(() => parcelRequire('0UymV'));